/* Hide the "Engraved Plaque" add-on from the predictive search dropdown only.
   Scoped to <predictive-search> so it never affects the cart (where the plaque must show). */
(function () {
  'use strict';
  var SEL = 'predictive-search a[href*="/products/engraved-plaque"]';
  function clean() {
    document.querySelectorAll(SEL).forEach(function (a) {
      var item = a.closest('li, [class*="predictive"], [class*="result"], [class*="suggestion"]') || a;
      item.remove();
    });
  }
  function start() {
    clean();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(clean, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
